import { createSvgIcon } from 'shared/icons/IconUtils';

export const SwapIcon = createSvgIcon(
  'SwapVert',
  <path
    d="M8 13V5.825L5.425 8.4L4 7L9 2L14 7L12.575 8.4L10 5.825V13H8ZM15 22L10 17L11.425 15.6L14 18.175V11H16V18.175L18.575 15.6L20 17L15 22Z"
    fill="currentColor"
  />,
);
